import { createSelector } from 'reselect'
import type { RootState } from '../../../store/types'
import { PmsIntegration, PmsIntegrationErrorCode } from '../../axios/pms/pmsIntegrations/types'
import { NO_PMS_INTEGRATION } from '../../axios/pms/pmsIntegrations/constants'

export const selectPmsIntegration = (state: RootState): PmsIntegration | null =>
	state.pmsIntegration?.integration ?? null

export const selectIsPmsIntegrationEnabled = (state: RootState): boolean =>
	!!state.pmsIntegration?.integration?.enabled

export const selectIsPmsIntegrationConnected = createSelector(
	selectPmsIntegration,
	(integration): boolean => !!integration?.enabled && integration.pms !== NO_PMS_INTEGRATION
)

export const selectPmsIntegrationIsSaving = (state: RootState): boolean =>
	!!state.pmsIntegration?.isSaving

export const selectPmsIntegrationErrorCode = (state: RootState): PmsIntegrationErrorCode | null =>
	state.pmsIntegration?.errorCode ?? null
